import { render, staticRenderFns } from "./MarketplaceRatesPopup.vue?vue&type=template&id=f7516a1c&scoped=true"
import script from "./MarketplaceRatesPopup.vue?vue&type=script&lang=js"
export * from "./MarketplaceRatesPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7516a1c",
  null
  
)

export default component.exports